import { useEffect, useState } from "react";

export default function PromoBanner({ promo }) {
  const [remaining, setRemaining] = useState("");
  useEffect(() => {
    if (!promo?.ends_at) return;
    const tick = () => {
      const end = new Date(promo.ends_at).getTime();
      const now = Date.now();
      const diff = Math.max(0, end - now);
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      setRemaining(
        d > 0 ? `${d}d ${h}h left` :
        h > 0 ? `${h}h ${m}m left` :
        `${m}m left`,
      );
    };
    tick();
    const id = setInterval(tick, 60000);
    return () => clearInterval(id);
  }, [promo?.ends_at]);
  return (
    <div className="hpz-promo-banner" data-testid="plaza-promo-banner">
      <span className="hpz-promo-banner__badge">{promo.badge_label}</span>
      <span className="hpz-promo-banner__copy">{promo.banner_copy}</span>
      <span className="hpz-promo-banner__count">{remaining}</span>
    </div>
  );
}
